<template>
  <Block type="accountSetting" id="safeQuession">
    <common-header
      is-passport
      :show-back="!isSDK"
      :show-lang="!isSDK"
      :title="accountLanguages.securityQuestion"
    ></common-header>
    <p
      class="quession-title question-content"
      :class="$platformClass"
      v-if="mapQuessions.length == 0 && quessionGroups[0].length > 1"
    >
      {{ accountLanguages.securityQuestionTips }}
    </p>
    <p
      class="quession-title question-content"
      :class="$platformClass"
      v-if="validateOldQuession"
    >
      {{ accountLanguages.validateQuessionTips }}
    </p>
    <form
      class="quession-form"
      :class="$platformClass"
      v-if="
        mapQuessions.length == 0 &&
        quessionGroups.length > 0 &&
        quessionGroups[0].length > 1
      "
    >
      <div
        class="quession-containner"
        v-for="(quessionGroup, index) in quessionGroups"
        v-bind:key="index"
      >
        <label
          class="select-label"
          :class="$platformClass"
          v-if="quessionGroup.length > 1"
        >
          <select
            class="quession-select"
            :class="$platformClass"
            v-bind:disabled="disableAll"
            v-model="answers[index].id"
          >
            <option
              v-bind:value="quession.id"
              v-bind:disabled="quession.disabled || disableAll"
              v-bind:selected="quession.selected"
              v-for="(quession, quessionIndex) in quessionGroup"
              v-bind:key="quessionIndex"
            >
              {{ quession.text }}
            </option>
          </select>
          <Icon type="quessionSelect" class="select-icon"></Icon>
        </label>
        <label
          class="editor-wrapper bgWhite"
          :class="$platformClass"
          v-if="quessionGroup.length > 1"
        >
          <input
            class="editor bgWhite"
            :class="$platformClass"
            v-model="answers[index].answer"
            v-bind:placeholder="accountLanguages.answerTips"
            v-bind:disabled="disableAll"
          />
        </label>
      </div>
      <label class="agree-wrapper email-send-btn" :class="$platformClass">
        <Button
          class="btn account-setting-submit"
          data-asyncbtn
          @click="postAnswer"
          :type="$isOmni ? 'lightfill' : 'fillLight'"
        >
          <Icon type="commonBtnLeft"></Icon>
          <Icon type="commonBtnRight"></Icon>
          {{ accountLanguages.submit }}
        </Button>
      </label>
    </form>
    <ValidateQuession
      :validateQuessions="mapQuessions"
      :quessionRef="CHANGE_QUESSION_REF"
      v-if="validateOldQuession"
      v-on:validateSuccess="setValidateToken"
      @showErrorTips="showErrorTips"
    ></ValidateQuession>
    <SubmitSuccessTips
      v-if="successValidate"
      :tips="accountLanguages.reSetSecurityQuessoon"
    ></SubmitSuccessTips>
    <label
      class="agree-wrapper rebind-email"
      :class="$platformClass"
      v-if="successValidate"
    >
      <Button
        class="btn account-setting-submit"
        :type="$isOmni ? 'lightfill' : 'fillLight'"
        @click="reSetSecurityQuessoon"
      >
        <Icon type="commonBtnLeft"></Icon>
        <Icon type="commonBtnRight"></Icon>
        {{ accountLanguages.modify }}
      </Button>
    </label>
    <transition name="fade">
      <Dialog v-show="showDialog"></Dialog>
    </transition>
    <transition name="fade">
      <Tost v-show="showTost"></Tost>
    </transition>
    <PopupWindow
      @onCancel="showPopup = false"
      @onConfirm="showPopup = false"
      type="tips"
      v-if="showPopup"
      :languages="accountLanguages"
      :content="errTips"
    ></PopupWindow>
  </Block>
</template>
<script>
import {
  LOAD_SAFE_QEUSSION,
  SET_QUESSION,
  EMPTY_QUESSIONS,
  SET_RESET_QUESSION_TOKEN,
  CHANGE_QUESSION_REF,
} from '../../store/passport/accountSetting';
import AccountSettingMixins from '../../mixins/AccountSetting';
import ValidateQuession from '../../components/passport/ValidateQuession';
import commonHeader from '@/resource/components/support/header';
import globalConfig from '../../utiles/globalConfig';
let initAnswer = function (len) {
  let answers = [];
  for (let i = 0; i < len; i++) {
    answers.push({
      id: '',
      answer: '',
    });
  }
  return answers;
};

export default {
  name: 'safeQuession',
  beforeCreate() {
    this.$store.dispatch(LOAD_SAFE_QEUSSION);
  },
  data() {
    return {
      answers: initAnswer(1),
      disableAll: false,
      validateOldQuession: false,
      validateAnswer: [],
      validateToken: '',
      CHANGE_QUESSION_REF,
      isSDK: false,
    };
  },
  computed: {
    quessionGroups() {
      return this.$store.state.accountSetting.quessionGroups;
    },
    mapQuessions() {
      return this.$store.state.accountSetting.mapQuessions;
    },
    successValidate() {
      return this.mapQuessions.length > 0 && !this.validateOldQuession;
    },
  },
  watch: {
    mapQuessions(quessions) {
      this.validateAnswer = [];
      for (var i = 0, len = quessions.length; i < len; i++) {
        var answer = {
          id: quessions[i].id,
          answer: '',
        };
        this.validateAnswer.push(answer);
      }
    },
    accountLang(val) {
      this.$store.dispatch(LOAD_SAFE_QEUSSION, {
        appLanguage: val,
        language: val,
        notNeedInitLanguage: true,
      });
    },
    quessionGroups: {
      deep: true,
      immediate: true,
      handler() {
        this.answers = initAnswer(
          this.$store.state.accountSetting.quessionGroups.length
        );
      },
    },
  },
  methods: {
    postAnswer() {
      this.$store
        .dispatch(SET_QUESSION, {
          answers: this.answers,
          other: {
            appLanguage: this.accountLang,
            language: this.accountLang,
            notNeedInitLanguage: true,
          },
        })
        .then(success => {
          if (success) {
            // 忘记当初为啥要全部disable编辑。在纯白平台测试的时候提出这个问题。 当初整理需求的澎龙离职。ujoy没有禁止编辑，故放开限制
            // this.disableAll = true;
          }
        })
        .catch(err => {
          this.showErrorTips(err.message);
        });
    },
    reSetSecurityQuessoon() {
      //   this.$store.commit(EMPTY_QUESSIONS)
      this.validateOldQuession = true;
      this.$store.commit(SET_RESET_QUESSION_TOKEN, '');
    },
    setValidateToken(token) {
      this.validateToken = token;
      this.$store.commit(EMPTY_QUESSIONS);
      this.validateOldQuession = false;
    },
  },
  created() {
    let hasSdkToken = !!globalConfig.getHrefParam('sdkToken');
    let isWeb = +globalConfig.getHrefParam('web') === 1;
    let isH5 = +globalConfig.getHrefParam('h5') === 1;
    this.isSDK = hasSdkToken || (isWeb && isH5);
  },
  mixins: [AccountSettingMixins],
  components: {
    ValidateQuession,
    commonHeader,
  },
};
</script>
